<template>
  <div class="comics-chapter-page">
    <div class="actions">
      <div @click="showScale = !showScale" :class="{ active: showScale }" class="sort-btn">
        <i class="sort-icon" /> <span v-if="isDesktop">Настройки чтения</span>
      </div>
      <button @click="addFav(post.parts[partIndex])" class="dbtn blue">
        Запомнить главу
      </button>
      <button v-if="!loadChapter && !loadChapterLink" @click="partDownload(partIndex)" class="dbtn green">Скачать главу</button>
      <span v-else-if="loadChapter && !loadChapterLink"><i class="loader"></i>Подготовка архива... Пожалуйста, подождите.</span>
      <a :href="loadChapterLink" target="_blank" v-else-if="!loadChapter && loadChapterLink" download class="load">
        Архив готов. Скачать.
      </a>
      <a :href="`/comics/${post.id}`">
        <i class="close" />
      </a>
    </div>

    <transition name="toBottom">
      <div v-if="showScale" class="settings">
        <div class="scale">
          <strong>Масштаб</strong>
          <input type="range" v-model="imgsWidth" min="0" max="9" step="1">
          <span v-if="imgsWidth > 0">-{{ imgsWidth }}0%</span>
          <span v-else>100%</span>
        </div>

        <div class="views">
          <strong>Показывать</strong>
          <span @click="setView('pages')" :class="{ active: imgsView === 'pages' }">Постранично</span>
          <span @click="setView('lenta')" :class="{ active: imgsView === 'lenta' }">Лентой</span>
        </div>
      </div>
    </transition>

    <div style="padding:20px 20px 0px;">
      <h1>
        <nuxt-link :to="`/comics/${post.id}`">
          {{ post.title }}
        </nuxt-link>
      </h1>

      <div class="ch-nav">
        <nuxt-link v-if="imgsValue >= 1" :to="`/comics/${post.id}/chapter/${imgsValue - 1}`">
          &larr;
        </nuxt-link>

        <select v-model="imgsValue">
          <option
            v-for="(ch, index) in post.parts"
            :key="`select-chapter-${index}`"
            :value="index"
          >
            {{ ch.title }}
          </option>
        </select>

        <nuxt-link v-if="post.parts.length - 1 > imgsValue" :to="`/comics/${post.id}/chapter/${+imgsValue + 1}`">
          &rarr;
        </nuxt-link>
      </div>

      <!-- <div class="h3" v-if="imgs && partIndex !== null" :class="{ active: turnOffValue }">
        {{ post.parts[partIndex].title }}
      </div> -->
      <!-- <button v-if="!showPremiumValue" @click="showPremium" class="dbtn red">
        Убрать рекламу
      </button> -->
    </div>

    <div v-if="imgsView === 'pages'" class="modal" style="text-align: center;">
      <div class="pagination">
        <ul v-if="imgs" :style="'width:' + (imgs.length * 63) + 'px'">
          <li v-for="(img, index) in imgs" :key="`imgs-img-${index}`">
            <span @click="setImg(index)" :class="{ active: index === imgIndex }">{{ index }}</span>
          </li>
        </ul>
      </div>
      <!-- <div class="imgs-nav">
        <span v-if="imgIndex >= 1" @click="setImg(imgIndex - 1)">
          &larr; Пред.
        </span>
        <span v-if="imgs.length - 1 > imgIndex" @click="setImg(+imgIndex + 1)">
          След. &rarr;
        </span>
      </div> -->

      <div class="img-wrapper">
        <img v-if="img" :src="img" @click="setImg(+imgIndex + 1)" :style="`width:calc(100% - ${imgsWidth}0%)`" class="imgs chapter-img">
        <span><i class="loader"/>Загрузка изображения</span>
      </div>


      <!-- <adSense v-if="showAds" /> -->
      <!-- <div class="imgs-nav">
        <span v-if="imgIndex >= 1" @click="setImg(imgIndex - 1)">
          &larr; Пред.
        </span>
        <span v-if="imgs.length - 1 > imgIndex" @click="setImg(+imgIndex + 1)">
          След. &rarr;
        </span>
      </div> -->
      <div class="pagination">
        <ul v-if="imgs && imgIndex !== null" :style="'width:' + (imgs.length * 63) + 'px'">
          <li v-for="(img, index) in imgs" :key="`imgs-img-second-${index}`">
            <span @click="setImg(index)" :class="{ active: index === imgIndex }">{{ index }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else-if="imgsView === 'lenta'" class="modal" style="text-align: center;">
      <div v-for="(img, index) in imgs" :key="`lenta-img-${index}-${partIndex}`">
        <div class="img-wrapper">
          <img :data-src="img" src="/static_files/no-poster.png" :style="`width:calc(100% - ${imgsWidth}0%)`" class="imgs lazy lazyload chapter-img">
          <span><i class="loader"/>Загрузка изображения {{ index }}</span>
        </div>
      </div>
    </div>

    <div style="padding:20px;">
      <div class="ch-nav">
        <nuxt-link v-if="imgsValue >= 1" :to="`/comics/${post.id}/chapter/${imgsValue - 1}`">
          &larr;
        </nuxt-link>

        <select v-model="imgsValue">
          <option
            v-for="(ch, index) in post.parts"
            :key="`select-chapter-${index}`"
            :value="index"
          >
            {{ ch.title }}
          </option>
        </select>

        <nuxt-link v-if="post.parts.length - 1 > imgsValue" :to="`/comics/${post.id}/chapter/${+imgsValue + 1}`">
          &rarr;
        </nuxt-link>
      </div>
    </div>

    <p class="hint">
      Не грузятся изображения? Включение VPN в 99% случаев решает проблему.
      <!-- Не грузятся изображения? <nuxt-link to="/vpn" style="color: red;">Читайте тут про VPN</nuxt-link>. -->
    </p>

    <p v-if="isDesktop && imgs" class="hint">
      Для вашего удобства изображения можно перелистывать стрелками клавиатуры <strong>"&larr; влево"</strong> и <strong>"вправо &rarr;"</strong>, а так же по клику на само изображение.
      Кнопка <strong>"Запомнить главу"</strong> добавляет текущую главу в закладки. Последняя прочитанная глава комикса отображается в профиле.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  layout: 'chapter',
  head() {
    const post = this.post
    const title = `${post.title}. Глава ${this.imgsValue} бесплатно на русском`
    if (post) {
      return {
        title: title,
        link: [
          {
            hid: 'canonical',
            rel: 'canonical',
            href: `https://anime777.site/comics/${post.id}/chapter/${this.imgsValue}`
          }
        ],
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: `комикс ${post.title} глава ${this.imgsValue}`
          },
          {
            hid: 'description',
            name: 'description',
            content: `Вы читаете мангу ${post.title}. Глава ${this.imgsValue} онлайн бесплатно с переводом на русский!`
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: `https://anime777.site/comics/${post.id}/chapter/${this.imgsValue}`
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: title
          },
          {
            hid: 'og:description',
            name: 'og:description',
            content: `Вы читаете мангу ${post.title}. Глава ${this.imgsValue} онлайн бесплатно с переводом на русский!`
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: post.poster
          }
        ]
      }
    }
  },
  watch: {
    imgsWidth(val) {
      localStorage.setItem('comics:width', ('' + val))
    },
    imgsView(val) {
      localStorage.setItem('comics:view', ('' + val))
      this.lazyLoadImgs()
    },
    imgsValue(val) {
      this.$router.push(`/comics/${this.post.id}/chapter/${val}`)
    }
  },
  computed: mapState(['isDesktop', 'user']),
  async asyncData({ params, $axios, query, redirect }) {
    const { data } = await $axios.get(`/api/comics/${params.id}`)

    // if (data.blocked && !query.fav) {
    //   return redirect(`/comics/${params.id}`)
    // }

    return {
      isBlocked: data.blocked,
      id: params.id,
      post: data.post,
      imgs: null,
      img: null,
      imgsValue: params.ch,
      partIndex: 0,
      imgsWidth: 0,
      showScale: false,
      imgsView: 'pages',
      loadChapter: false,
      loadChapterLink: '',
      gets: {}
    }
  },
  mounted() {
    if (!this.user && this.isBlocked) return this.$router.push(`/comics/${this.post.id}`)

    window.addEventListener('keyup', this.switchImgListener)
    this.getImgs(this.imgsValue)

    if (localStorage.getItem('comics:width')) {
      this.imgsWidth = localStorage.getItem('comics:width')
    }

    if (localStorage.getItem('comics:view')) {
      this.imgsView = localStorage.getItem('comics:view')
    }

    setTimeout(() => {
      if (this.imgsView === 'lenta') {
        this.lazyLoadImgs()
      }
    }, 1000)
  },
  methods: {
    checkImgsUrl() {
      const imgs = document.querySelectorAll('.chapter-img')

      imgs.forEach(el => {
        // console.log('el.src', el.src)

        if (el.complete && el.naturalHeight !== 0) {
          console.log('success')
        } else {
          el.src = el.src.includes('/img2.')
            ? el.src.replace('/img2.', '/img.')
            : el.src.replace('/img.', '/img2.')
        }
      })
    },
    async addFav(part) {
      if (this.user) {
        const obj = {
          user_id: this.user.id,
          date: Date.now(),
          type: 'comics',
          action: 'watching',
          id: this.id,
          part: this.post.parts[this.partIndex].title,
          part_id: this.partIndex,
          title_ru: this.post.title,
          poster: this.post.poster
        }
        await this.$axios.post('/api/user/favs', obj)
        this.$store.commit('setError', { status: 'ok', msg: 'Сохранено в закладки' })
        setTimeout(() => this.$store.commit('clearError'), 1100)
      } else {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        this.$store.commit('setShowAuthForm', true)
      }
    },
    setView(type) {
      this.imgsView = type
    },
    async partDownload(part) {
      this.loadChapter = true
      const body = {
        id: this.id,
        part
      }
      const { data } = await this.$axios.post(`/api/comics/download`, body)
      this.loadChapter = false

      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        this.loadChapterLink = data
      }
    },
    switchImgListener(event) {
      // console.log('keyCode', event.keyCode)
      const elemChat = document.querySelector('.chat .global')
      if (elemChat) return
      if (event.keyCode === 37) {
        this.setImg(this.imgIndex - 1)
      } else if (event.keyCode === 39) {
        this.setImg(this.imgIndex + 1)
      }
    },
    async getImgs(index, event = null) {
      // console.log(index, this.partIndex)
      // if (
      //   (!this.user && this.isBlocked) ||
      //   (this.user && this.user.group !== 777 && this.isBlocked)
      // ) {
      //   this.$store.commit('setError', {
      //     status: 'warn',
      //     msg: 'Доступ ограничен по просьбе правообладателя'
      //   })
      //   setTimeout(() => this.$store.commit('clearError'), 3000)
      //   return
      // }

      // if (this.gets.getImgs || +index === this.partIndex) return
      // const blockList = ['DF Studio']
      // if (blockList.some(el => this.post.translation.includes(el))) {
      //   this.$store.commit('setError', {
      //     status: 'warn',
      //     msg: 'Доступ ограничен по просьбе переводчика'
      //   })
      //   setTimeout(() => this.$store.commit('clearError'), 3000)
      //   return
      // }
      this.$store.commit(
        'setError',
        { status: 'load', msg: `Идет загрузка ${this.post.parts[index].title}` }
      )

      const { data } = await this.$axios.post(`/api/comics/${this.id}/${index}`, { link: this.post.parts[index].link })
      this.imgs = data
      this.imgsValue = index
      this.partIndex = index
      this.img = data[0]
      this.imgIndex = 0

      this.$store.commit('clearError')

      setTimeout(() => {
        if (this.turnOffValue) {
          const popupEl = document.querySelector('.actions')
          if (popupEl) {
            popupEl.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
        }
        // else {
        //   const popupEl = document.querySelector('.actions')
        //   if (popupEl) {
        //     popupEl.scrollIntoView({ block: 'start', behavior: 'smooth' })
        //   }
        // }
      }, 100)

      // if (this.user) {
      //   const obj = {
      //     date: Date.now(),
      //     type: 'comics',
      //     user_id: this.user.id,
      //     title_ru: this.post.title,
      //     id: this.id,
      //     poster: this.post.poster
      //   }
      //   this.$axios.post(`/api/user/history`, obj)
      // }

      setTimeout(() => {
        this.checkImgsUrl()
      }, 2000)
    },
    setImg(index) {
      if (index >= this.imgs.length || index < 0) return
      // const img = document.querySelector('.parts img')
      // img.src = ''
      this.img = ''
      this.$nextTick(() => {
        this.img = this.imgs[index]
        this.imgIndex = index
        if (this.turnOffValue) {
          setTimeout(() => {
            const el = document.querySelector('.popup .imgs-nav')
            if (el) el.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }, 100)
        } else {
          setTimeout(() => {
            const el = document.querySelector('.comics .pagination')
            if (el) el.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }, 100)
        }
        this.$nextTick(() => {
          const pUl = document.querySelectorAll('.pagination')
          if (pUl) {
            pUl.forEach(el => {
              el.scrollTo((index - 1) * 63, 0)
            })
          }
        })

        setTimeout(() => {
          this.checkImgsUrl()
        }, 2000)
      })
    }
  }
}
</script>

<style lang="stylus">
.comics-chapter-page
  color: #ddd
  background-color #222
  min-height: 100vh
  .img-wrapper
    position: relative
    min-height: 40px
    background-color: #2a2a2a
    .loader
      width: 24px
      height: 24px
      background-size: 24px
      vertical-align: middle
    span
      position: absolute
      top: 0px
      left: calc(50% - 80px)
      font-size: 1.4rem
      color: #999
      line-height: 40px
    img
      position: relative
      z-index: 1

  .load
    color: #fff
    border-bottom: 2px solid red
  .loader
    width: 20px
    height: 20px
    background-size: 20px
  .hint
    color: #ddd
    background-color: #333
  .actions
    position relative
    padding 20px
    background-color #222
    z-index 3
    i.close
      display inline-block
      position fixed
      top 10px
      right 30px
      width 44px
      height 44px
      padding 10px
      background rgba(255 255 255 .35) url('/static_files/icons/cancel-dark.svg') no-repeat center
      background-size 14px
      border-radius 50%
      opacity .75
      cursor pointer
      transition opacity .2s ease
      &:hover
        opacity 1
  .dbtn
    background-color #222
    border-color #444
    color #ddd
  input[type="range"]
    vertical-align middle
    margin 10px
  select
    display inline-block
    // margin 20px 0
    color #ddd
    background-color #222
    border 1px solid #ddd
  .ch-nav
    margin-bottom 20px
    text-align center
    a
      color: #ddd
    span
      display inline-block
      margin 0 10px
      padding 10px
      font-size 1.5rem
      color #ddd
      cursor pointer
      transition color .2s ease
      &:hover
        color #fff
  .sort-btn
    margin 0
    color #ddd
    border-radius: 20px
    padding: 4px 16px
    border: 2px solid #666
    background-color #333
    i
      background-image url('/static_files/icons/settings-dark.svg')
  .settings-btn
    display inline-block
    padding 6px 18px
    font-size 1.4rem
    color #ddd
    background-color #444
    border-radius 5px
    cursor pointer
    transition background-color .2s ease
    &:hover
      background-color #00bcd4
    &.active
      background-color #00bcd4
    .sort-icon
      display inline-block
      width 20px
      height 20px
      background-image: url('/static_files/icons/settings-dark.svg')
      background-size: 20px
      vertical-align bottom
  .settings
    padding 0 20px
    font-size 1.4rem
    color #fff
    .scale
      margin-bottom 10px
    .views
      strong
        margin-right 10px
      span
        margin-right 5px
        padding 4px 12px
        border-radius 20px
        cursor pointer
        &.active
          background-color #b8a177
          color #fff
          font-weight bold

  h1
    margin 0 0 20px
    a
      color: #fff
  .modal
    padding 20px 20px 30px
    background-color #222
    .imgs-nav
      text-align center
      span
        display inline-block
        margin 0 10px
        padding 10px
        font-size 1.5rem
        color #ddd
        cursor pointer
        transition color .2s ease
        &:hover
          color #fff
    .pagination
      position relative
      width 100%
      overflow-x auto
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar-track
        height 7px
        background #222
      &::-webkit-scrollbar
        height 7px
      &::-webkit-scrollbar-thumb
        background #222
      &:hover::-webkit-scrollbar-thumb
        background #b8a177
.pagination
  margin 20px 0
  // z-index 3

</style>
